import ResizableForm from "../mixins/ResizableForm";

Vue.asyncComponent('cms-inbox-detail',{
    mixins: [ResizableForm],
    data() {
        return {
            showModal: false,
            form: null,
            entry: null,
            answers: [],
            nextObjectId: null,
            prevObjectId: null,
            loading: false,
        }
    },
    props: {
        objectId: {
            type: String,
            required: true
        }
    },
    computed: {
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return `inbox-detail-width`;
        }
    },
    methods: {
        /**
         * Fetch data
         *
         * Get the answers and next/prev object Id's for this current inbox entry
         * @returns {Promise<void>}
         */
        async fetchData() {
            this.showModal = false;
            this.loading = true;
            const path = this.$getSetting('paths.baseCms') + '/inbox/entry-detail/' + this.objectId;
            const result = await this.$get(path);

            this.form = result.form;
            this.entry = result.entry;
            this.answers = result.answers;
            this.nextObjectId = result.nextObjectId;
            this.prevObjectId = result.prevObjectId;

            this.showModal = true;
            this.loading = false;
        },
        /**
         * Go to previous entry
         */
        goToPrevEntry() {
            this.goToEntry(this.prevObjectId);
        },
        /**
         * Go to next entry
         */
        goToNextEntry() {
            this.goToEntry(this.nextObjectId);
        },
        /**
         * Go to entry
         * @param objectId
         */
        goToEntry(objectId) {
            this.$router.push({
                name: 'inbox-detail',
                params: {objectId: objectId},
                query: this.$route.query
            });
        },
        /**
         * Close modal
         */
        close() {
            // go to the parent route
            this.$router.push({
                ...this.$route.matched[0],
                query: this.$route.query
            });
        },
        /**
         * Go to the edit form page
         */
        editForm() {
            // @todo change this to the correct params when form flow is ready
            this.$router.push({
                name: 'form',
                params: {
                    bundle: 'form',
                    gridDefinition: 'grid',
                    definition: 'form',
                    objectId: this.form.id,
                }
            })
        },
        /**
         * Go to the edit form layout page
         */
        editFormLayout() {
            // @todo change this to the correct params when form flow is ready
            this.$router.push({
                name: 'blueprint',
                params: {
                    blueprintId: this.form.blueprintId,
                },
                query: {
                    verticalId: this.form.verticalId,
                }
            });
        }
    },
    created() {
        this.fetchData();
    }
}, 'cms/inbox/cms-inbox-detail.html');
